import type { FeedComponentDto, OrganizationDto } from "@strtmn/sds/types"
import { I18n } from "aws-amplify/utils"
import { useState } from "react"
import { getLinkToOrgFeedComponent } from "../../../LinkUtils"
import {
  CURRENCY_SYMBOL,
  pricePerKgToPerLargeMass,
  UNIT_OF_LARGE_MASS,
} from "../../../org-settings"
import {
  ensureImagePath,
  getFeedComponentGroupLabel,
} from "./FeedComponentUtils"
import { ListItem } from "./ListItem"

interface FeedComponentProps {
  className?: string
  org: OrganizationDto
  item: FeedComponentDto
  details?: string | React.ReactNode
  hasViewButton?: boolean
  hasEditButton?: boolean
}

/**
 * A ListItem representing a Feed Component.
 * Used in
 *   - /feed-components/
 *     - ts-gehalt
 *     - preis
 *   - /recipes/:recipeId
 *     - weight (in that recipeId)
 * @returns
 */
export default function FeedComponentItem({
  className,
  org,
  item,
  details,
  hasViewButton = true,
  hasEditButton = false,
}: FeedComponentProps) {
  const feedComponent = item as FeedComponentDto
  const [imageSrc, setImageSrc] = useState<string>("")

  ensureImagePath(feedComponent, imageSrc, setImageSrc)

  if (!details) {
    details = (
      <>
        {Number(feedComponent.ts_gehalt_percent) > 0 ? (
          <div>
            TS-Gehalt:{" "}
            {`${feedComponent.ts_gehalt_percent!.toLocaleString(undefined, { maximumFractionDigits: 1 })}%`}
          </div>
        ) : (
          <div>Gewicht nach Frischmasse</div>
        )}
        <div>
          {I18n.get("Kategorie")}:{" "}
          {I18n.get(getFeedComponentGroupLabel(feedComponent.group))}
        </div>
        <div>
          Preis:{" "}
          {feedComponent.price_per_kg
            ? `${pricePerKgToPerLargeMass(feedComponent.price_per_kg).toLocaleString(undefined, { maximumFractionDigits: 2 })} ${CURRENCY_SYMBOL} / ${UNIT_OF_LARGE_MASS} FM`
            : "nicht angegeben"}
        </div>
      </>
    )
  }

  return (
    <ListItem
      key={feedComponent.id}
      className={`feed-component ${className}`}
      title={feedComponent.name}
      href={getLinkToOrgFeedComponent(org, feedComponent.id, false)}
      imageSrc={imageSrc}
      details={details}
      hasViewButton={hasViewButton}
      hasEditButton={hasEditButton}
      size="small"
    />
  )
}
